__turbopack_context__.v({
  "SpecializationCard__InnerImage": "SpecializationMbaCard-module-scss-module__rIDr5G__SpecializationCard__InnerImage",
  "SpecializationCard__InnerShowMoreIcon": "SpecializationMbaCard-module-scss-module__rIDr5G__SpecializationCard__InnerShowMoreIcon",
  "SpecializationCard__InnerTitle": "SpecializationMbaCard-module-scss-module__rIDr5G__SpecializationCard__InnerTitle",
  "SpecializationCard__background": "SpecializationMbaCard-module-scss-module__rIDr5G__SpecializationCard__background",
  "specializationsCarousel": "SpecializationMbaCard-module-scss-module__rIDr5G__specializationsCarousel",
  "sponsored-image": "SpecializationMbaCard-module-scss-module__rIDr5G__sponsored-image",
  "sponsored-image-wrapper": "SpecializationMbaCard-module-scss-module__rIDr5G__sponsored-image-wrapper",
  "swiper-slide": "SpecializationMbaCard-module-scss-module__rIDr5G__swiper-slide",
});
